import "./InfoAvailable.scss";

const InfoAvailable = () => {
  return (
    <div className="info-available">
      <section>
        <div>
          <div id="info">
            <div id="title">
              <div className="line" />
              <p>Une équipe à votre écoute</p>
            </div>
            <p>
              Nous répondons à vos besoins quels que soient votre usage et votre
              domaine d'activité : entreprises de propreté et syndics,
              collectivités, établissements de santé, hôtellerie et
              restauration, etc. <br />
              <br /> Notre équipe commerciale est à votre disposition pour
              répondre à vos besoins. Visite des sites afin de déterminer vos
              problématiques et définir les solutions adaptées, suivi
              personnalisé tout au long du processus commercial, installation
              sur site et service après-vente si nécessaire.
              <br />
              <br /> 1500 m2 d'entrepôt, notre équipe de préparateurs de
              commandes et notre équipe de chauffeurs-livreurs sont disponibles
              afin de préparer vos commandes et d'effectuer des livraisons
              rapides sur vos sites suivant vos besoins.
            </p>
          </div>
          <div className="img-container">
            <div className="image-container">
              <img
                src="/images/about/info-available.png"
                alt="info-available"
              />
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default InfoAvailable;
